import { cn } from '@utils/helpers';
import { HEADER_COL_STYLES } from './helpers';
import type { PriceInfoHeaderProps } from './types';

export const PriceInfoHeader: React.FC<PriceInfoHeaderProps> = ({ tableheader }) => {
  return (
    <thead className="max-desktop:pl-[5px] max-[620px]:pr-0.5">
      <tr className="max-desktop:flex max-desktop:flex-wrap max-desktop:items-stretch">
        {tableheader?.map((header) => (
          <th key={header?.col} className={cn('font-normal', HEADER_COL_STYLES[header?.col ?? ''])}>
            {header?.label}
          </th>
        ))}
      </tr>
    </thead>
  );
};
